import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { fetchAllCategory } from "helpers/category_helper";
import { deleteSubCategory, fetchAllSubCategory, updateSubCategory } from "helpers/subCategory_helper";
import Select from "react-select"
const AllSubCategories = (props) => {
    document.title = "Content Management | All Categories";
    const [modalShow, setModalShow] = useState(false);
    const [category, setCategory] = useState(null);
    const [subCategoryName, setSubCategoryName] = useState("");
    const [subCategoryDescription, setSubCategoryDescription] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [id, setId] = useState({});
    const [loader, setLoader] = useState(false);
    const [allSubCategory, setAllSubCategory] = useState([]);
    const [page, setPage] = useState(1);
    const [categories, setCategories] = useState([]);

    const breadcrumbItems = [
        { title: "Sub Category", link: "#" },
        { title: "All Sub Categories", link: "#" },
    ]

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('All Sub Categories', breadcrumbItems);
    })



    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();

            if (data?.success) {
                setCategories(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }


    const fetchSubCategories = async () => {
        try {
            const data = await fetchAllSubCategory();

            if (data?.success) {
                setAllSubCategory(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchSubCategories();
        fetchCategories();
    }, []);

    const data = {
        columns: [
            {
                label: "Serial No.",
                field: "serialNo",
                sort: "asc",
                width: 50,
            },
            {
                label: "Name",
                field: "name",
                sort: "asc",
                width: 150,
            },
            {
                label: "Description",
                field: "description",
                sort: "asc",
                width: 200,
            },
        ],
        rows: allSubCategory,
        rows: allSubCategory?.map((row, index) => ({
            ...row,
            serialNo: index + 1, // Add 1 to start counting from 1
            clickEvent: () => handleRowClick(row)
        }))
    }

    const handleRowClick = (row) => {

        setModalShow(true);
        setId(row?.id);
        setSubCategoryName(row?.name);
        setSubCategoryDescription(row?.description);
        setCategory(row?.categoryDto)
    }

    const handleUpdate = async () => {
        try {
            if (!subCategoryDescription || !subCategoryName || !category) {
                setSpanDisplay("inline");
            }
            else {
                setLoader(true);
                const data = await updateSubCategory({ id, name: subCategoryName, description: subCategoryDescription, categoryDto: category });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setModalShow(false)
                    fetchSubCategories();
                }
                else {
                    toast.error(data?.message);
                }
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }


    const handleDelete = async () => {
        try {
            setLoader(true);
            const data = await deleteSubCategory(id);
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message);
                setModalShow(false);
                setDeleteModalShow(false);
                fetchSubCategories();
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }


    const handleSelectCategory = selectedOption => {
        setCategory(selectedOption);
    };

    return (
        <React.Fragment>

            {loader ? (
                <>
                    < Loader />
                </>
            ) : ("")}


            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4">All Sub Categories </CardTitle>
                            <MDBDataTable
                                className="table-row-hover"
                                responsive
                                bordered
                                data={data}
                                style={{ cursor: 'pointer' }}
                                noBottomColumns
                                paging={{ page, onPageChange: setPage }}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Modal for  edit sub category  */}
            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Sub Category
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Category
                        </label>
                        <div className="col-md-10">
                            <Select

                                value={category}
                                onChange={handleSelectCategory}
                                options={categories}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!category && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Sub Category Name
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Class"
                                value={subCategoryName}
                                maxLength="50"
                                onChange={(e) => setSubCategoryName(e.target.value)} />
                            {!subCategoryName && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Sub Category Description
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Description"
                                value={subCategoryDescription}
                                maxLength="50"
                                onChange={(e) => setSubCategoryDescription(e.target.value)} />
                            {!subCategoryDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setModalShow(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
                    <Button type="button" color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false) }} className="waves-effect waves-light">Delete</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for delete confirmation  */}
            <Modal
                show={deleteModalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Sub Category.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModalShow(false); setModalShow(true) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllSubCategories);